export function getTabsConfig() {
  return {
    efficiency: [],
    ['factory-gpt']: [],
  };
}
